import { supabase, isSupabaseEnabled } from '../config/supabase';

export const logConversion = async (sourceFormat, targetFormat, fileSize, userId = null) => {
  if (!isSupabaseEnabled) return null;

  try {
    const { data, error } = await supabase
      .from('conversion_logs')
      .insert([
        {
          source_format: sourceFormat,
          target_format: targetFormat,
          file_size: fileSize,
          user_id: userId,
          timestamp: new Date().toISOString()
        }
      ]);

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Failed to log conversion:', error);
    return null;
  }
};

export const getUserConversions = async (userId) => {
  if (!isSupabaseEnabled) return [];

  try {
    const { data, error } = await supabase
      .from('conversion_logs')
      .select('*')
      .eq('user_id', userId)
      .order('timestamp', { ascending: false })
      .limit(50);

    if (error) throw error;
    return data || [];
  } catch (error) {
    console.error('Failed to fetch user conversions:', error);
    return [];
  }
};

export const signInWithEmail = async (email, password) => {
  if (!isSupabaseEnabled) return { user: null, error: new Error('Supabase not configured') };

  try {
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password
    });
    return { user: data.user, error };
  } catch (error) {
    return { user: null, error };
  }
};

export const signUpWithEmail = async (email, password) => {
  if (!isSupabaseEnabled) return { user: null, error: new Error('Supabase not configured') };

  try {
    const { data, error } = await supabase.auth.signUp({
      email,
      password
    });
    return { user: data.user, error };
  } catch (error) {
    return { user: null, error };
  }
};

export const signOut = async () => {
  if (!isSupabaseEnabled) return { error: null };

  try {
    const { error } = await supabase.auth.signOut();
    return { error };
  } catch (error) {
    return { error };
  }
};

export const getCurrentUser = async () => {
  if (!isSupabaseEnabled) return null;

  try {
    const { data: { user } } = await supabase.auth.getUser();
    return user;
  } catch (error) {
    console.error('Failed to get current user:', error);
    return null;
  }
};